<template>
  <section
    :id="section.id"
    class="content-section"
  >
    <div
      class="planet bg-image"
      :style="{ backgroundImage: planetBackgroundImage ? `url('${planetBackgroundImage}')` : '' }"
    />
    <div class="bg-black">
      <div class="container">
        <div class="big-content">
          <div :class="section.is_visible ? 'fade-in' : 'fade-out'">
            <h2 class="local-title">
              {{ getContent('last_section.block_1_title') }}
            </h2>
            <p class="content-text mb-8">
              {{ getContent('last_section.block_1_description') }}
            </p>
          </div>
          <div
            :class="section.is_visible ? 'fade-in' : 'fade-out'"
            :style="{ transitionDelay: getFadeTransitionDelay(1) }"
          >
            <h2 class="local-title">
              {{ getContent('last_section.block_2_title') }}
            </h2>
            <p class="content-text mb-8">
              {{ getContent('last_section.block_2_description') }}
            </p>
          </div>
          <div
            :class="section.is_visible ? 'fade-in' : 'fade-out'"
            :style="{ transitionDelay: getFadeTransitionDelay(2) }"
          >
            <h2 class="local-title">
              {{ getContent('last_section.block_3_title') }}
            </h2>
            <p class="content-text">
              {{ getContent('last_section.block_3_description') }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="ships bg-image"
      :style="{ backgroundImage: shipsBackgroundImage ? `url('${shipsBackgroundImage}')` : '' }"
    />
  </section>
</template>

<script>
export default {
  name: 'ContentSectionLast',
  data: () => ({
    section: {
      id: contentSectionId.last,
      is_visible: true,
    },
    previousSection: {
      id: contentSectionId.three,
      is_visible: false,
    },
    planetBackgroundImage: null,
    shipsBackgroundImage: null,
  }), 
  watch: {
    'previousSection.is_visible': {
      once: true,
      handler(isVisible) {
        if (!isVisible) return;

        if (!this.planetBackgroundImage) {
          const image = useImage()
          this.planetBackgroundImage = image('/content_last_section_planet.webp')
        }

        if (!this.shipsBackgroundImage) {
          const image = useImage()
          this.shipsBackgroundImage = image('/content_last_section_space_ships.webp')
        }
      },
    },
  },
  mounted() {
    this.section.is_visible = false;
    initObserver(this.section);
    initObserver(this.previousSection);

    const el = document.getElementById(this.previousSection.id)
    if (el) {
      const r = el.getBoundingClientRect()
      if (r.bottom <= 0) {
        this.previousSection.is_visible = true
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.content-section {
  padding-top: 64px;
  margin-bottom: -170px;

  .planet {
    height: 301px;
  }

  .container {
    z-index: 2;
    position: relative;
    transform: translateY(-73px);

    .local-title {
      margin-left: 16px;
      margin-bottom: 20px;
    }

    .content-text {
      border: 1px $yellow-100 dashed;
      border-radius: 16px;
      padding: 16px;
      height: 100%;
    }
  }

  .ships {
    z-index: 1;
    height: 800px;
    position: relative;
    transform: translateY(-170px);
  }
}

@media only screen and (max-width: $xl) {
  .content-section {
    padding-top: 64px;
    margin-bottom: -214px;

    .ships {
      transform: translateY(-215px);
    }
  }
}

@media only screen and (max-width: $sm) {
  .content-section {
    padding-top: 32px;
    margin-bottom: 234px;

    .container {
      transform: translateY(-111px);
    }

    .ships {
      height: 460px;
      transform: translateY(-186px);
    }
  }
}
</style>
